var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424F62",
    stroke: "#424F62",
    strokeWidth: 0.2,
    d: "M12.381 3.804l-.516-.516c-.384-.384-1.053-.384-1.437 0l-.668.667-.001.002-.002.002-3.975 3.975c-.044.043-.072.1-.08.161l-.259 1.807c-.013.089.017.178.08.242.055.055.127.084.203.084.013 0 .027 0 .04-.003l1.807-.258c.06-.008.118-.037.161-.08l3.975-3.975.001-.002.002-.002.668-.667c.192-.192.298-.447.298-.718 0-.272-.106-.527-.297-.719zM7.398 9.415l-1.335.191.19-1.336 3.708-3.706 1.144 1.144-3.707 3.707zm4.579-4.579l-.468.468-1.144-1.144.467-.468c.168-.168.46-.168.628 0l.517.516c.084.084.13.196.13.315 0 .118-.046.23-.13.313zm.166 3.202v2.38c0 1.209-.983 2.191-2.19 2.191H5.19c-1.208 0-2.19-.982-2.19-2.19V5.657c0-1.208.982-2.19 2.19-2.19h2.381c.159 0 .286.128.286.285 0 .158-.128.286-.286.286h-2.38c-.893 0-1.62.726-1.62 1.619v4.762c0 .893.727 1.619 1.62 1.619h4.761c.893 0 1.62-.726 1.62-1.62v-2.38c0-.158.128-.286.285-.286.158 0 .286.128.286.286z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.76d5344ae878f0a73d15eb662564025a.svg";
export { ForwardRef as ReactComponent };